(function($) {
  $(window).load(function() {

    if ($.fn.stellar && $(window).width() > 767) {

      $.stellar({
        horizontalScrolling: false,
        horizontalOffset: 0,
        verticalOffset: 80, /* Fixes jump after load */
        hideDistantElements: false,
        responsive: false,
        positionProperty: 'transform'
      });

    }

  });
})(jQuery);
